module.exports = __webpack_public_path__ + "static/media/gastronomia.1d51c90f.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/banners/categoria-interesse/gastronomia.jpg
// module id = 1834
// module chunks = 10